// PC 키보드 단축키 — ← 이전, → 다음, T 오늘(이번 주).
// 입력 중(텍스트 필드 등)이거나 다이얼로그·팝오버·메뉴가 열려 있으면 동작하지 않는다.
// T는 한글 입력 상태(ㅅ)에서도 동작하도록 e.key가 아닌 키 위치(e.code)로 판별한다.
// 길게 눌러 반복 입력되는 키는 무시한다(주마다 조회 요청이 몰리는 것 방지).
import { useEffect, useRef } from "react";

const EDITABLE = "input, textarea, select, [contenteditable=''], [contenteditable='true'], [role='textbox']";

export default function useCalendarShortcuts({ onPrev, onNext, onToday }) {
  const handlers = useRef({ onPrev, onNext, onToday });
  handlers.current = { onPrev, onNext, onToday };

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.defaultPrevented || e.repeat || e.isComposing) return;
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (e.target instanceof Element && e.target.closest(EDITABLE)) return;
      if (document.querySelector(".MuiModal-root:not(.MuiModal-hidden)")) return;

      const { onPrev, onNext, onToday } = handlers.current;
      if (e.key === "ArrowLeft") onPrev();
      else if (e.key === "ArrowRight") onNext();
      else if (e.code === "KeyT") onToday();
      else return;
      e.preventDefault();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);
}
